export enum EConsommableAir {
    GelosePCA = 1,
    GeloseSabouraud = 2
}